import { createContext } from 'react';

import type {
    AuthorizedMedicationInfoFragment,
    DigitallyReceivedPrescriberOrderInfoFragment,
    UnclaimedPrescriberOrderInfoFragment,
} from '../graphql/generated/graphql';

export type PrescriberOrderCtx = {
    medication: AuthorizedMedicationInfoFragment | undefined;
    order:
        | DigitallyReceivedPrescriberOrderInfoFragment
        | UnclaimedPrescriberOrderInfoFragment;
    orderId: string;
};

export const PrescriberOrderContext = createContext<PrescriberOrderCtx | null>(
    null
);
